import { takeLatest, call, put } from 'redux-saga/effects';
import { notify } from 'react-notify-toast';
import { push } from 'react-router-redux';
import { sendNewPassAdmin } from 'api';
import { URLS } from 'config';
import { showLoadScreen, hideLoadScreen } from 'components/LoadScreen/actions';
// import { generateNextRoute } from 'utilz';

import * as actions from './actions';


function* sendNewPass(action) {
  const { payload: { pass } } = action;
  try {
    yield put(showLoadScreen());
    const result = yield call(sendNewPassAdmin, pass);
    console.log(result.data.message);
    yield put(hideLoadScreen());
    if (result.data.message === 'ok') {
      yield put(push(URLS.LOGINADMIN));
      notify.show(`${result.data.message}`, 'success', 5000);
    }
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
    notify.show(`${err.data.message} | ${err.data.type}`, 'error', 5000);
  }
}


export default function* () {
  yield takeLatest(
    actions.SEND_NEW_PASS,
    sendNewPass
  );
}



// WEBPACK FOOTER //
// ./src/pages/AdminRestorePass/saga.js